if (typeof ScrollingText !== "function") {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			var ScrollingText = (function () {
				function getWidth(element) {
					var rect = element.getBoundingClientRect();
					return rect.right - rect.left;
				}

				function ScrollingText(box, speed) {
					var inner_element = (box.children && box.children[0]) || null;
					if (!inner_element) throw "No child node found";

					inner_element.style.position = "relative";

					this.position = 0;
					this.speed = speed;
					this.box_width = getWidth(box);
					this.inner_element_width = getWidth(inner_element);
					this.box = box;
					this.inner_element = inner_element.cloneNode(true);
					// Duplicated copies are visual only; screen readers read the text once.
					this.inner_element.setAttribute("aria-hidden", "true");
					setUpChildrens.call(this);
				}

				function refreshWidths() {
					this.box_width = getWidth(this.box);
					this.inner_element_width = getWidth(this.box.children[0]);
				}

				function calculateNumElements() {
					return Math.ceil(this.box_width / this.inner_element_width) + 1;
				}

				function setUpChildrens() {
					var qty = calculateNumElements.call(this);
					if (qty > this.box.children.length) {
						for (var i = this.box.children.length; i < qty; i++)
							this.box.appendChild(this.inner_element.cloneNode(true));
					} else if (qty < this.box.children.length) {
						for (var i = qty; i < this.box.children.length; i++)
							this.box.removeChild(this.box.lastChild);
					}
				}

				function nextFrame(delta, direction) {
					var self = this;
					refreshWidths.call(this);
					setUpChildrens.call(this);
					Array.prototype.forEach.call(this.box.children, function (el) {
						if (direction == "rtl") {
							el.style.transform = `translateX(${self.position}px)`;
						} else {
							el.style.transform = `translateX(${-self.position}px)`;
						}
					});
					this.position += (this.speed * delta) / 1000;
					if (this.position >= this.inner_element_width)
						this.position = this.position % this.inner_element_width;
				}

				ScrollingText.prototype = {
					start: function (direction, speed) {
						if (this._running) return;
						this._running = true;
						var self = this;
						var last_time = null;
						var loop_func = function () {
							if (!self._running) return;
							var now = Date.now();
							var delta = last_time === null ? 0 : now - last_time;
							nextFrame.call(self, delta, direction, speed);
							last_time = now;
							window.requestAnimationFrame(loop_func);
						};
						window.requestAnimationFrame(loop_func);
					},

					stop: function () {
						this._running = false;
					},
				};

				return ScrollingText;
			})();

			const speed = window.innerWidth > 768 ? parseInt(this.dataset.scrollingSpeed) : parseInt(this.dataset.scrollingSpeed) / 1.5;
			const direction = this.dataset.scrollingDirection;
			const scrolling_text = new ScrollingText(this, speed, direction);
			const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

			// WCAG 2.2.2: moving content needs a control to pause it. Paused state is
			// set by the user (button) or by the "reduce motion" system setting.
			let userPaused = reduceMotion;
			let hoverPaused = false;
			let focusPaused = false;
			let inView = false;

			const toggle = document.createElement("button");
			toggle.type = "button";
			toggle.className = "scrolling-text__toggle";
			const pauseIcon = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="3" y="2" width="4" height="12"/><rect x="9" y="2" width="4" height="12"/></svg>';
			const playIcon = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6z"/></svg>';
			const updateToggle = () => {
				toggle.setAttribute("aria-label", userPaused ? "Play scrolling text" : "Pause scrolling text");
				toggle.setAttribute("aria-pressed", userPaused ? "true" : "false");
				toggle.innerHTML = userPaused ? playIcon : pauseIcon;
			};
			const sync = () => {
				if (inView && !userPaused && !hoverPaused && !focusPaused) {
					scrolling_text.start(direction);
				} else {
					scrolling_text.stop();
				}
			};
			toggle.addEventListener("click", () => {
				userPaused = !userPaused;
				updateToggle();
				sync();
			});
			updateToggle();
			// Placed next to (not inside) the marquee, whose children are animated.
			if (this.parentNode) {
				this.parentNode.style.position = "relative";
				this.parentNode.insertBefore(toggle, this.nextSibling);
			}

			if (this.dataset.pauseOnHover == "true") {
				this.addEventListener("mouseenter", () => { hoverPaused = true; sync(); });
				this.addEventListener("mouseleave", () => { hoverPaused = false; sync(); });
			}
			// Keyboard users get the same pause while focus is inside the marquee.
			this.addEventListener("focusin", (e) => { if (e.target !== toggle) { focusPaused = true; sync(); } });
			this.addEventListener("focusout", () => { focusPaused = false; sync(); });

			const intersectionObserver = new IntersectionObserver(entries => {
				inView = entries[0].isIntersecting;
				sync();
			});
			intersectionObserver.observe(this);
		}
	}

	if (typeof customElements.get("scrolling-text") == "undefined") {
		customElements.define("scrolling-text", ScrollingText);
	}
}
